<template>
  <div id="ul_Easy" v-if="!active.private" style="width: 240px;" class="noselect">
    <div v-for="level in groupedUsers" :key="level.id">
      <span class="level_titles" v-if="level.users.length > 0" :style="{ color: level.color }">{{ level.title }}</span>
      <ul>
        <li v-for="user in level.users" :key="user.user_id" :class="{ 'selected': selectedUser === user.user_id }"
          @click="selectedUser = user.user_id" @contextmenu.prevent="showContextMenu($event, user, level.title)">

          <Avatar :label="user.nickname.charAt(0).toUpperCase()" :style="getAvatarStyle(user.gender)" shape="circle"
            v-if="!user.avatar" />
          <Avatar :image="$utils.getAvatar(user.avatar)" shape="circle" v-else :class="'avatar_gender_'+user.gender"/>
        <div class="easy_list_info">
          <span class="easy_list_nickname" :style="{ color: level.color }">{{ user.nickname }}</span>
          <span class="easy_list_status" v-if="user.extra" :style="{ color: '#'+user.extra.color }">{{ user.extra.title }}</span>
        </div>
        </li>
      </ul>
    </div>
    <UserContextMenu :user="userData" ref="userContextMenu" @select="onMenuSelect" :blocks="blocks" :follows="follows" />

  </div>
  <div v-else id="profileArea">
    <ProfileCard :profile="active.profile"></ProfileCard>
  </div>

  <BanDialog :userData="userData" ref="banDialog" :channel="active"/>


</template>

<script>

import UserContextMenu from './chat_parts/UserContextMenu.vue';
import ProfileCard from './chat_parts/ProfileCard.vue';
import BanDialog from './dialogs/BanDialog.vue';


export default {
  props: ['active', 'blocks', 'follows'],
  emits: ['selectMenu'],
  components: {
    UserContextMenu, ProfileCard,BanDialog
  },
  data() {
    return {
      userData: {
        nickname: null,
        avatar: null,
      },
      selectedUser: null,
      visibleBanDialog: false,

    };
  },

  computed: {
    groupedUsers() {
      return this.active.levels.map(level => ({
        ...level,
        users: this.active.users.filter(user => user.access === level.access).sort((a, b) => a.nickname.localeCompare(b.nickname))
      }));
    }
  },
  methods: {
    getAvatarStyle(gender) {
      if (gender === 1) {
        return { backgroundColor: '#2196F3', color: '#ffffff' };
      } else if (gender === 2) {
        return { backgroundColor: '#FFC0CB', color: '#ffffff' };
      } else if (gender > 2) {
        return {
          background: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)',
          color: '#ffffff'
        };
      } else {
        return { backgroundColor: '#2196F3', color: '#ffffff' };
      }
    },
   
    showContextMenu(event, user, level) {
      this.userData = { ...user, channel_access: level };

      if (this.$refs.userContextMenu && typeof this.$refs.userContextMenu.show === 'function') {
        this.$refs.userContextMenu.show(event);
      } 
    },
    onMenuSelect(action) {
      if (action === 'kick') {
        this.$refs.banDialog.showDialog();
        return;
      }
      this.$emit('selectMenu', { action, user: this.userData });
    }
  }
};
</script>


<style scoped>
#ul_Easy {
  background-color: var(--p-neutral-50);
  color: rgb(0, 0, 0);
  border-left: 1px solid var(--p-neutral-300);
  width: 240px;
  float: left;
  height: 100%;
  overflow: auto;
}

#ul_Easy ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.easy_list_info
{
  display: flex;
  flex-direction: column;
}
#ul_Easy ul li {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  cursor: pointer;
  padding: 4px 0 4px 10px;
}

#ul_Easy ul li.selected {
  background-color: var(--p-neutral-300);

}

#ul_Easy .level_titles {
  font-size: 0.9rem;
  font-weight: 500;
  padding-left: 10px;
  margin-top: 10px;
  display: block;
  color: var(--p-neutral-300);
}

#ul_Easy .p-avatar {
  margin-right: 5px;
}

#ul_Easy .easy_list_nickname {
  font-size: 14px;
  font-weight: 600;
  line-height: 1rem;
  margin-left: 6px;
}

#ul_Easy .easy_list_status {
  font-size: 12px;
  margin-left: 6px;
}



#ul_Easy .p-avatar.p-avatar-lg {
  width: 2rem;
  height: 2rem;
}

#profileArea {
  height: 100%;
  width: 374px;
  float: left;
  background: var(--p-neutral-50);
  overflow: auto;

}
</style>
